<template>
    <div class="container">
      <!-- 左侧导航 -->
      <!-- <el-backtop target=".contents" :visibility-height="100" style="z-index: 9999;">
                <div
                   class="back-to-top">
                    回到顶部2
                </div>
                </el-backtop> -->

      <el-row class="row">
        <el-col :span="6" class="sidebar"  @scroll="handleScroll">
          <!-- 搜索框 -->
          <el-input
            v-model="searchQuery"
            placeholder="搜索文档"
            prefix-icon="el-icon-search"
            class="search-input"
          />
    
          <!-- 自定义的菜单 -->
          <ul class="custom-menu">
           <div     v-for="(item, index) in filteredTableData" 
           :key="item.document_id">
                    <li 
                    
                    :class="{'active-parent': activeParentIndex === index}" 
                    >
                    <div 
                        @click="handleSelect(index)" 
                        class="menu-item"
                    >
                        {{ item.name }}
                    </div>
                  
                    </li>
                    <li v-if="item.flag">
                        <ul >
                        <li
                        v-for="(itemA, indexA) in item.document_sections"
                        :key="itemA.document_sections_id"
                        :class="{'active-sub': activeSubIndex === indexA}" 
                        @click="handleSelectA(itemA.document_sections_id, indexA)"
                        class="sub-menu-item"
                        >
        
                        <div>{{ itemA.name }}</div>
                        </li>
                    </ul>
                    </li>
           </div>
    
          </ul>
        </el-col>
    
        <!-- 右侧内容 -->
        <el-col :span="18" class="content">
          <div v-if="detail">
            <h2>{{ detail.name }}</h2>
            <div class="content-body">
              <p v-html="detail.intro"></p>
            </div>
    
            <!-- <div
                   class="back-to-top">
                    回到顶部1
                </div> -->

            </div>
        </el-col>
      </el-row>
    </div>
  </template>
  
  <script>
  import DocumentApi from '@/api/document.js';
  
  export default {
    data() {
      return {
        tableData: [], // 所有操作文档
        searchQuery: "", // 搜索框的输入内容
        activeParentIndex: null, // 当前选中的父分类索引
        activeSubIndex: null, // 当前选中的子分类索引
        showBackToTop: false, // 是否显示回到顶部按钮
        formInline: {},
        detail: {}
      };
    },
    created() {
      this.getTableList();
    },

    computed: {
      // 根据搜索查询过滤文档
      filteredTableData() {
        if (!this.searchQuery) {
          return this.tableData; // 返回所有数据
        }
        // 返回过滤后的数据
        return this.tableData.filter(item =>
          item.name.toLowerCase().includes(this.searchQuery.toLowerCase()) || // 过滤文档名称
          item.document_sections.some(section =>
            section.name.toLowerCase().includes(this.searchQuery.toLowerCase()) // 过滤文档章节名称
          )
        );
      }
    },
    methods: {
      getTableList() {
        let self = this;
        let Params = this.formInline;
        self.loading = true;
        DocumentApi.search(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data; // 获取所有文档数据
          })
          .catch(error => {});
      },
      getDetail(document_sections_id) {
        let self = this;
        let Params = { document_sections_id: document_sections_id };
        DocumentApi.searchDetail(Params, true)
          .then(data => {
            self.detail = data.data;
          })
          .catch(error => {});
      },
      // 选择父分类
      handleSelect(index) {
        // 如果当前父分类已经选中，则取消选中（即收起）
        if (this.activeParentIndex === index) {
          this.activeParentIndex = null;
          this.tableData[index].flag = false; // 收起子分类
          this.activeSubIndex = null; // 清除子分类选中
        } else {
          // 否则选中当前父分类
          this.activeParentIndex = index;
          this.tableData[index].flag = true; // 展开子分类
  
          // 收起其他父分类的子分类
          this.tableData.forEach((item, idx) => {
            if (idx !== index) {
              item.flag = false; // 关闭其他父分类
            }
          });
  
          // 清除其他父分类的子分类选中状态
          if (this.activeSubIndex !== null && this.activeParentIndex !== index) {
            this.activeSubIndex = null; // 清除子分类选中
          }
        }
      },
      // 选择子分类
      handleSelectA(document_sections_id, subIndex) {
        // 如果点击的子分类是当前选中的子分类，取消选中；否则选中当前子分类
        this.activeSubIndex = this.activeSubIndex === subIndex ? null : subIndex;
        this.getDetail(document_sections_id);
      },
      // 监听滚动，显示回到顶部按钮
      handleScroll(event) {
            console.log('Scroll position:', event.target.scrollTop);
            if (event.target.scrollTop > 300) {
            this.showBackToTop = true;
            } else {
            this.showBackToTop = false;
            }
        },
      // 回到顶部
      scrollToTop() {
        console.log('1111111111')
        document.documentElement.scrollTop = 0; // 直接跳转到顶部
        document.body.scrollTop = 0;           // 兼容处理
      }
    }
  };
  </script>
  
  <style scoped>
  .container {
    display: flex;
    height: 100vh; /* 100% 屏幕高度 */
  }
  
  .row {
    width: 100%;
  }
  
  .sidebar {
    background-color: #f5f5f5;
    padding: 20px;
    height: 100vh; /* 设置高度为 100vh，确保占满屏幕 */
    max-height: 100vh; /* 设置最大高度为 100vh */
    overflow-y: auto; /* 允许滚动，当内容过多时 */
    flex-shrink: 0; /* 确保 sidebar 不会收缩 */
  }
  
  .search-input {
    margin-bottom: 20px;
    width: 100%;
  }
  
  .custom-menu {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .menu-item {
    padding-left: 20px;
    cursor: pointer;
  }
  
  .sub-menu-item {
    padding-left: 40px;
    cursor: pointer;
  }
  
  .content {
    padding: 20px;
    background-color: #fff;
    height: 100%; /* 填满剩余空间 */
    box-sizing: border-box;
  }
  
  .content-body {
    margin-top: 20px;
    line-height: 1.6;
  }
  
  .back-to-top {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 999;
    background-color: #409EFF;
    border-radius: 50%;
    padding: 10px;
    color: white;
    font-size: 10px;
    width: 55px;
    height: 55px;
    text-align: center;
  }
  
  /* 父分类选中项样式 */
  .active-parent {
    color: #409EFF; /* 设置父分类选中项的文字颜色 */
  }
  
  /* 子分类选中项样式 */
  .active-sub {
    color: #409EFF; /* 设置子分类选中项的文字颜色 */
  }
  
  @media (max-width: 1200px) {
    .container {
      flex-direction: column;
    }
  
    .sidebar {
      width: 100%;
      margin-bottom: 20px;
    }
  
    .content {
      width: 100%;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/plus/document/index/search.vue